import { type Block, type ReviewState, WithoutIdAndReview, PhilatelicItemType } from "@briefmarken_katalog/types";
import type { TranslationKey } from "$lib/i18n";
import { CollectionEditorModelBase } from "./CollectionEditorModelBase.svelte";

export class BlockEditorModel extends CollectionEditorModelBase<Block> {
  size_width: number = $state(0);
  size_height: number = $state(0);

  constructor({
    onCreate = (_block: WithoutIdAndReview<Block>) => {},
    onReview = (_block: WithoutIdAndReview<Block>, _state: ReviewState) => {},
    onDelete = () => {},
    isReadonly = false,
    isReview = false,
    isDelete = false,
    isEdit = false,
    initialValue = null,
    dialogTitle = 'editor.blockEditorTitle' as TranslationKey,
    dialogSubtitle = 'editor.blockEditorSubtitle' as TranslationKey,
  }: {
    onCreate?: (block: WithoutIdAndReview<Block>) => void;
    onReview?: (block: WithoutIdAndReview<Block>, state: ReviewState) => void;
    onDelete?: () => void;
    isReadonly?: boolean;
    isReview?: boolean;
    isDelete?: boolean;
    isEdit?: boolean;
    initialValue?: Block | null;
    dialogTitle?: TranslationKey;
    dialogSubtitle?: TranslationKey;
  } = {}) {
    super({ onCreate, onReview, onDelete, isReadonly, isReview, isDelete, isEdit,
            initialValue, dialogTitle, dialogSubtitle });

    if (initialValue) {
      this.size_width = initialValue.size?.width ?? 0;
      this.size_height = initialValue.size?.height ?? 0;
    }
  }

  override handleImageUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      this.pictures = [{ base64: e.target?.result as string }];
      this.picturesDirty = true;
    };
    reader.readAsDataURL(file);
  }

  override setPictureFromPhone(picture: import('@briefmarken_katalog/types').ImageType): void {
    this.pictures = [picture];
    this.picturesDirty = true;
  }

  override reset() {
    super.reset();
    this.size_width = 0;
    this.size_height = 0;
  }

  buildItem(): WithoutIdAndReview<Block> {
    return {
      title: this.title,
      description: this.description,
      date_of_issue: this.date_of_issue!,
      expiry_date: this.expiry_date ?? undefined,
      size: { width: this.size_width, height: this.size_height },
      print_run: this.print_run ?? undefined,
      categories: this.categories.length > 0 ? this.categories : undefined,
      catalog_ids: Object.keys(this.catalog_ids).length > 0 ? this.catalog_ids : undefined,
      zhihao: this.zhihao,
      pictures: this.pictures,
      stamps: this.stampIds,
      type: PhilatelicItemType.Block,
    };
  }
}
